<template>
  <div class="setting-fontsize">
    フォントサイズ&nbsp;:&nbsp;
    <i-button size="small" :type="isActiveSmall" @click="onClickButton(10)">小</i-button>
    <i-button size="small" :type="isActiveMedium" @click="onClickButton(12)">中</i-button>
    <i-button size="small" :type="isActiveLarge" @click="onClickButton(14)">大</i-button>
  </div>
</template>

<script>
import { Button } from 'view-design'
export default {
  components: {
    'i-button': Button,
  },
  props: {
    fontSize: {
      type: Number,
      default: 12,
      requied: true,
    },
  },
  computed: {
    _fontSize: {
      get() {
        return this.fontSize
      },
      set(val) {
        this.$emit('update:fontSize', val)
      },
    },
    isActiveSmall() {
      return this.fontSize === 10 ? 'primary' : 'default'
    },
    isActiveMedium() {
      return this.fontSize === 12 ? 'primary' : 'default'
    },
    isActiveLarge() {
      return this.fontSize === 14 ? 'primary' : 'default'
    },
  },
  created() {
    // ローカルストレージに値がある場合は、設定値に反映
    const fontSize = JSON.parse(localStorage.getItem('fontSize'))
    if (fontSize) this._fontSize = fontSize
  },
  methods: {
    // ボタンクリック時のフォントサイズ変更処理
    onClickButton(fontSize) {
      // ローカルストレージに保存する
      localStorage.setItem('fontSize', JSON.stringify(fontSize))
      this._fontSize = fontSize
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-fontsize {
  display: inline-block;
  .ivu-btn {
    margin-right: 4px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
